import { UserService } from './../../../Shared/Services/user.service';
import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { Observable } from 'rxjs';
import { FinraException } from './finra-exception.model';
import { ConstantService } from 'app/Shared/Services/constant-service';

@Injectable()
export class FinraExceptionService {
  showView!: boolean;
  showEdit!: boolean;
  showROEEdit!: boolean;
  pageSize!: number;
  pageNumber!: number;
  sortField!: string;
  sortOrder!: number;
  showCounterpartyReport!: boolean;
  
  finraExceptions!: FinraException[];
  
  defaultFilters!: any[];
  lastExecutionCATDates!: any[];
  catFieldTypes: any = [];

  FINRAEXCEPTION_URL: string;
  showCreateParentScreen: boolean = false;
  groupListDropDown: any = [];
  modifiedFlagList: any = ['N','U','D','C','G','F'];

  constructor(
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    public constantService: ConstantService,
  ) {
    this.FINRAEXCEPTION_URL = this.urlsService.setAPIURl(APIURL.FINRA_EXCEPTION);
    this.getGroupList();
  }

  getGroupList() {
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.CAT_Get_Group_List),
      {
        validationType: "CAT",
        mpid: this.userService.getActiveMPID(),
        reportDate: this.userService.getyyyyMMddDateFormate(this.userService.getyyyyMMddDateFormate(this.getReportDate(new Date())))
      }
    ).subscribe(response => {
      let result = response;
      this.groupListDropDown = [];
      let DataSet: any[] = result.Data;
      if (DataSet && DataSet.length > 0) {
        for (let i = 0; i < DataSet.length; i++) {
          this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName });
        }
      }
    });
  }

  getReportDate(today:any) {
    if (today.getDay() == 6) {
      today.setDate(today.getDate() + 2);
    } else if (today.getDay() == 7) {
      today.setDate(today.getDate() + 1);
    }
    return today;
  }

  getFinraExceptions(
    defaultFilters: any,
    pageSize: number,
    pageNumber: number,
    sortField: string,
    sortOrder: number
  ): Observable<any> {
    // pagination parameters
    const params: HttpParams = new HttpParams()
      .append('pageNumber', pageNumber+"")
      .append('pageSize', pageSize+"")
      .append('sortField', sortField)
      .append('sortOrder', sortOrder+"");
    //date need to converted into yyyy-mm-dd for filter.
    const defaultFiltersData = JSON.parse(JSON.stringify(defaultFilters));
    defaultFiltersData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[0])));
    defaultFiltersData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[1])));
   // backend needs filter data with key as "data"
    const searchFilter = 
    { data: defaultFiltersData,
      mpid:this.userService.getActiveMPID()
    };
    return this.sharedHttpClientService.httpPostWithParams(
      this.FINRAEXCEPTION_URL,
      searchFilter,
      params
    );
  }
    
  deleteFinraExceptions(selectedId: number): Observable<any> {
    return this.sharedHttpClientService.delete(
      this.FINRAEXCEPTION_URL + 'delete/' +selectedId+'/'+this.userService.getUserFirstName()
    );
  }

  deleteMultipleFinraExceptions(selectedRow: any) {
    return this.sharedHttpClientService.post(
      this.FINRAEXCEPTION_URL + 'multidelete/',
      {
        recordsList:selectedRow,
        user:this.userService.getUserFirstName()
      }
    );
  }

  restoreFinraExceptions(selectedId: number): Observable<any> {
    return this.sharedHttpClientService.put(
      this.FINRAEXCEPTION_URL + 'restore/' + selectedId+'/'+this.userService.getUserFirstName(),
      {}
    );  
  }

  restoreMultipleFinraExceptions(selectedRow: any) {
    return this.sharedHttpClientService.post(
      this.FINRAEXCEPTION_URL + 'multirestore/',
      {
        recordsList:selectedRow,
        user:this.userService.getUserFirstName()
      }
    );
  }

  applySuggestedValuesFinraExceptions(selectedRow: any) {
    let optedRows = selectedRow.map(({ id, firmROEID, catReporterIMID, reportDate, failureCode }: any) => ({ id, firmROEID, catReporterIMID, reportDate, failureCode }))

    return this.sharedHttpClientService.post(
      this.FINRAEXCEPTION_URL + 'applySuggestedValues',
      {
        optedRows: optedRows,
        CATReporterIMID: this.userService.getActiveMPID(),
        userName: this.userService.getUserFirstName()
      }
    );
  }

  getFDID(givenNameForFDID:any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_Exception_Get_FDID
        ), {
          "mpid": this.userService.getActiveMPID(),
          "givenName": givenNameForFDID
      })      
  }

getDestinationList(reportDate:any) {
  const defaultFiltersData = JSON.parse(JSON.stringify(this.defaultFilters));
  defaultFiltersData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[0])));
  defaultFiltersData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[1])));

  return this.sharedHttpClientService.post(
    this.urlsService.setAPIURl(
      APIURL.Get_SenderIMID_DestinationType
      ), {
        "data": defaultFiltersData,
        "mpid":this.userService.getActiveMPID(),
        "reportDate":reportDate
    })   
}

  exportToJSON(reportDate:any) {

    const defaultFiltersData = JSON.parse(JSON.stringify(this.defaultFilters));
    defaultFiltersData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[0])));
    defaultFiltersData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFiltersData[0].values[1])));
   // backend needs filter data with key as "data"
    const searchFilter = 
    { data: defaultFiltersData,
      mpid:this.userService.getActiveMPID()
    };
    
    return this.sharedHttpClientService.postPlainText(
      this.urlsService.setAPIURl(
        APIURL.Finra_Exception_Repair_File
        ), searchFilter)      
  }


  
  saveFinraExceptions(selectedId: number,firmROEID:any,reportDate:any,updatedJSON:any): Observable<any> {
    
   return this.sharedHttpClientService.post(
      this.FINRAEXCEPTION_URL + 'save/',
      {
        "mpid":this.userService.getActiveMPID(),
        "rowID":selectedId,
        "firmROEID":firmROEID,
        "orignalJSON":updatedJSON,
        "reportDate":reportDate,
        "user":this.userService.getUserFirstName()
      }
    )
  }
  saveFinraExceptionsMultipleRecords(firmROEIDList:any,updatedJSON:any,originalJson:any,reportDate:any): Observable<any> {
    let multiEditPayload = {
      user:this.userService.getUserFirstName(),
      mpid: this.userService.getActiveMPID(),
      updatedJSON: updatedJSON,
      firmROEIDList: firmROEIDList,
      reportDate:reportDate,
      originalJSON: originalJson
    }
    return this.sharedHttpClientService.post(
       this.FINRAEXCEPTION_URL + APIURL.FINRA_Exception_MultiEdit,
       multiEditPayload
     )
   }
 

  getOriginalJSON(selectedId: number): Observable<any> {
    return this.sharedHttpClientService.get(
      this.FINRAEXCEPTION_URL + 'originaljson/' + selectedId
    );
  }

  getFiledDictionaryForEditView(selectedId: number): Observable<any> {
    return this.sharedHttpClientService.get(
      this.FINRAEXCEPTION_URL + 'editview/' + selectedId
    );
  }

  getLatestReportDate() {
    return this.userService.FinraCATLastExceptionReportDate
  }

  updateClientDataExceptionStatus(data:any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.FINRA_Update_Exception_Status
        ), data)
  }

  // this returns JSON which needs to be passed to filter panel
  getDefaultFilters(
    lastExecutionCATDates: any[],
    defaultParameterValues: any
  ): any [] {
    // convert list of types to comma separated string
    let catFieldTypesArrayList: any = [];
    let modifiedFlagList: any = (Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["modifiedFlag"] && defaultParameterValues["modifiedFlag"].length > 0) ? defaultParameterValues["modifiedFlag"] : this.modifiedFlagList;
    let failureCodeFilterBy = (Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["failureCode"] && defaultParameterValues["failureCode"].indexOf(',') > -1) ? "IN" : (defaultParameterValues["failureCodeFilterBy"] ? defaultParameterValues["failureCodeFilterBy"] : "=");
    let failureCodes = (Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["failureCode"] && defaultParameterValues["failureCode"].length > 0) ? defaultParameterValues["failureCode"] : "";
    let actualValue = (Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["actualValue"]) ? defaultParameterValues["actualValue"] : "";
    let status = (Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["status"] && defaultParameterValues["status"].length > 0) ? defaultParameterValues["status"] : '';

    const eventValues = [];
    let strEventValues = '';
    if(Object.keys(defaultParameterValues).length > 0 && defaultParameterValues["catFieldTypes"] && defaultParameterValues["catFieldTypes"].length > 0) {
      catFieldTypesArrayList = defaultParameterValues["catFieldTypes"];
      for (const event of defaultParameterValues["catFieldTypes"]) {
        eventValues.push(event.value);
        strEventValues = eventValues + ',';
      }
      // remove last comma
      strEventValues.substring(0, strEventValues.length - 1);
    }
    // copied structure from cat exception - ideally we should not repeat this 
    // - but values passed lastExecutionCATDates / catFieldTypesArrayList are little different
    // TODO need to make it common
    let defaultFilters: any = [];
    defaultFilters = [
      {
        isdefault: 'true',
        label: 'Date',
        columnname: 'reportDate',
        filterby: '',
        values: [lastExecutionCATDates[0],lastExecutionCATDates[1]],
        time: '',
        datatype: 'DateRange',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'Type',
        columnname: 'type',
        filterby: 'IS',
        values: eventValues,
        time: '',
        datatype: 'skip',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue: catFieldTypesArrayList,
      },
      {
        isdefault: 'true',
        label: 'Rsms Status',
        columnname: 'modifiedFlag',
        filterby: 'IN',
        values: modifiedFlagList,
        time: '',
        datatype: 'Array',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue: this.constantService.rsmsStatusDropDwn,
      },
      {
        isdefault: 'true',
        label: 'Firm ROEID',
        columnname: 'firmROEID',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      
      {
        isdefault: 'true',
        label: 'Symbol',
        columnname: 'symbol',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'Code',
        columnname: 'failureCode',
        filterby: failureCodeFilterBy,
        values: failureCodes,
        time: '',
        datatype: (failureCodes && failureCodes.indexOf(',') > -1 ? 'String' : 'Int'),
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
        isNeededINClauseAtOptions: true,
        isNeededOwnFilterOptions: true
      },
      {
        isdefault: 'true',
        label: 'Quantity',
        columnname: 'quantity',
        filterby: '=',
        values: '',
        time: '',
        datatype: 'Int',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'Price',
        columnname: 'price',
        filterby: '=',
        values: '',
        time: '',
        datatype: 'Float',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'Order ID',
        columnname: 'orderID',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'FirmDesignatedID',
        columnname: 'firmDesignatedID',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault:'true',
        label:"Destination",
        columnname:"destination",
        filterby:"IS",
        values:"",
        time:"",
        datatype:"String",
        disabled:"false"
      },
      {
        isdefault: 'true',
        label: 'Route ID',
        columnname: 'routedOrderID',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
        isdefault: 'true',
        label: 'sender IMID',
        columnname: 'senderIMID',
        filterby: 'IS',
        values: '',
        time: '',
        datatype: 'String',
        disabled: 'true',
        dropdown: '',
        dropdownvalue: '',
      },
      {
          isdefault:'true',
          label:"Error ROE ID",
          columnname:"errorROEID",
          filterby:"IS",
          values:"",
          time:"",
          datatype:"String",
          disabled:"false"
      }
    ];
    // Add ActualValue Filter Dynamically
    if(actualValue.length > 0) {
      defaultFilters = [...defaultFilters, {
        isdefault:'true',
        label:"Actual Value",
        columnname:"actualValue",
        filterby:"IS",
        values: actualValue,
        time:"",
        datatype:"String",
        disabled:"false"
     }];
    }
    // Add status Filter Dynamically
    if(status.length > 0) {
      defaultFilters = [...defaultFilters, {
        isdefault:'true',
        label:"Status",
        columnname:"status",
        filterby:"IS",
        values: status,
        time:"",
        datatype:"String",
        disabled:"false"
     }];
    }
    return defaultFilters;
  }
}
